<template>
  <div>
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active"><a href="javascript:;">CONTROL</a></li>
    </ol>
    <h1 class="page-header">Módulo Control</h1>
    <div class="card border-0">
      <div class="card-body">
        <button
          v-show="nuevoControl == 0"
          type="button"
          class="btn btn-warning"
          @click="
            nuevoControl = 1;
            nuevo = true;
          "
        >
          <i class="fa fa-plus"></i> Nuevo Control
        </button>
        &nbsp;
        <button
          v-show="nuevoControl == 1"
          type="button"
          class="btn btn-danger animated fadeIn"
          @click="nuevoControl = 0"
        >
          <i class="fa fa-list"></i> Ver Listado
        </button>
      </div>
      <procesando :tipo="1" v-if="proceso" />
    </div>
    <div
      v-show="
        nuevoControl == 0 && !proceso && this.$store.state.usuario.idtipo == '2'
      "
      class="row"
    >
      <div class="col-lg-4">
        <!--<local class="text-center"  :valor_entrada="filtro.local" v-model="filtro.local"
						@evento="filtro.local=$event;cargaForzada()" />-->
        <!-- <SelectPersonal :local="true"  :valor_entrada="filtro.local" v-model="filtro.local" @evento="filtro.local=$event;cargaForzada()"/> -->

        <select
          v-model="filtro.local"
          @change="alCambiarFiltro()"
          class="form-control font-weight-bold text-center"
          name="personal"
        >
          <option value="">Seleccione Personal</option>
          <option v-for="p in personal" :key="p.dni" :value="p.dni">
            {{ p.vendedor }}
          </option>
        </select>
      </div>
      <div class="col-lg-4">
        <select
          @change="alCambiarFiltro()"
          v-model="filtro.tipo"
          class="form-control font-weight-bold text-center"
        >
          <option value="">Seleccione Tipo</option>
          <option value="1">GLP</option>
          <option value="2">GNV</option>
          <option value="3">TRIMOVIL</option> 
          <option value="4">MODIFICACIÓN</option>
        </select>
      </div>
    </div>

    <div class="row animated fadeIn" v-show="nuevoControl == 0 && !proceso">
      <div class="col-xl-12">
        <registros
          ref="registros"
          :search="false"
          :porPagina="porPagina"
          :local="localSeleccionado"
          :field="'Id'"
          :columns="columns2"
          @eliminar="confirmar($event)"
          ocultarEditar="true"
          botonDuplicar="false"
          :placeholder="'Buscar por certificado o propietario'"
          :url="
            this.URL_BASE() +
            'control/search/' +
            filtro.local +
            '/' +
            filtro.tipo
          "
        >
          <template v-slot:detalle="slotProps">
            <!-- <a
              :href="
                '#/control/detalle/' +
                slotProps.detalle.dni +
                '/' +
                slotProps.detalle.personal.trim() +
                '/' +
                slotProps.detalle.tipo_descripcion +
                '/' +
                slotProps.detalle.inicial +
                '/' +
                slotProps.detalle.final
              "
              :title="slotProps"
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-list"> </i> VER
            </a> -->
			<router-link 
  :to="{ 
    name: 'controlDetalle', // El nombre que le pusiste en router.js
    params: { 
      dni: slotProps.detalle.dni,
      personal: slotProps.detalle.personal.trim(),
      tipo: slotProps.detalle.tipo_descripcion,
      inicial: slotProps.detalle.inicial,
      final: slotProps.detalle.final
    }
  }" 
  class="btn btn-danger btn-sm"
>
  <i class="fa fa-list"></i> VER
</router-link>
          </template>
        </registros>
      </div>
    </div>
    <div class="row animated fadeIn" v-if="nuevoControl == 1">
      <div class="col-xl-12">
        <control
          v-show="!proceso"
          @cancelar="nuevoControl = 0"
          @actualizar="actualizar($event)"
          @guardar="guardar($event)"
          :registro="control"
          :nuevo="nuevo"
        />
      </div>
    </div>
  </div>
</template>
<script>
import colum from "../columnasControl";
import control from "../components/Control.vue";
import registros from "../../../components/compartidos/Registros";
import procesando from "../../../components/compartidos/Procesando";
import local from "../../../components/compartidos/SelectLocales.vue";
import axios from "axios";
import SelectPersonal from "../../../components/compartidos/SelectPersonal.vue";

export default {
  name: "PageControl",
  components: {
    control,
    registros,
    procesando,
    local,
    SelectPersonal,
  },
  data() {
    return {
      personal: [],
      filtro: {
        local: "",
        tipo: "1",
      },
      cargaRegistros: true,
      localSeleccionado: "Todo",
      mesSeleccionado: "Todo",
      anioSeleccionado: "Todo",
      personalSeleccionado: "",
      proceso: false,
      nuevo: true,
      duplicar: false,
      control: null,
      nuevoControl: 0,
      porPagina: 10,
      columns2: colum.columnas,
    };
  },

  created() {
    this.cargarPersonal();
    this.verificadorUrl();
    setTimeout(() => {
      this.cargaRegistros = false;
    }, 1000);

    const query = this.$route.query;

    // Si hay algo en la URL, lo ponemos en las variables
    if (query.tipo || query.fecha) {
      this.filtro.local = query.local || "";
      this.filtro.tipo = query.tipo || "";
      this.cargaForzada(); // Ejecutamos la búsqueda automáticamente
    }
  },
  methods: {
	alCambiarFiltro() {
      // OJO: Aquí actualizamos la URL actual para "guardar" la selección
      // Usamos .replace para no llenar el historial innecesariamente, 
      // o .push si quieres que cada cambio de filtro sea un paso atrás.
      this.$router.replace({
        query: {
          ...this.$route.query, // Mantiene otros params si existen
          local: this.filtro.local,
          tipo: this.filtro.tipo
        }
      }).catch(()=>{}); // El catch evita errores de navegación duplicada
	  
      this.cargaForzada();
    },
    cargaForzada() {
      setTimeout(() => {
        this.refrescarTabla();
      }, 100);
    },
    refrescarTabla() {
      this.$refs.registros.loadItems();
    },
    actualizar(registro) {
      this.proceso = true;
      axios
        .put(this.URL_BASE() + "control/update/", registro)
        .then((respuesta) => {
          this.refrescarTabla();
          if (respuesta.data.msg == "exito") {
            this.exito("Control actualizado correctamente");
          }
          this.proceso = false;
        })
        .catch(function (error) {
          error.log("er store" + error);
        });
    },
    guardar(registro) {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "control/create/", registro)
        .then((respuesta) => {
          this.refrescarTabla();
          if (respuesta.data.msg == "exito") {
            this.exito("Control actualizado correctamente");
            this.nuevo = false;
            this.duplicar = false;
            this.control = {
              ...respuesta.data.dataAdicional[0],
            };
          }
          if (respuesta.data.msg == "repetido") {
            this.advertencia(
              "¡El certificado N°: " + respuesta.data.data + " ya existe!"
            );
          }

          this.proceso = false;
        })
        .catch(function (error) {
          error.log("er store" + error);
        });
    },
    confirmar(registros) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡Los registros seleccionados se eliminarán!",
        type: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn m-r-5 btn-warning",
        cancelButtonClass: "btn btn-default",
      }).then((result) => {
        if (result.value) {
          this.eliminar(registros);
          return true;
        } else if (result.dismiss) {
          return false;
        }
      });
    },
    eliminar(registros) {
      this.proceso = true;
      axios
        .put(this.URL_BASE() + "control/delete", registros)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.$swal("Proceso completado", "", "success");
          }
          this.proceso = false;
        })
        .catch(function (error) {
          error.log("er store" + error);
        });
    },
    verificadorUrl() {
      let anio = this.$route.params.anio;
      let mes = this.$route.params.mes;
      let idpersona = this.$route.params.idpersona;
      if (mes != undefined) {
        this.porPagina = -1;
        this.mesSeleccionado = parseInt(mes);
        this.anioSeleccionado = anio;
      }
      if (idpersona == "Todo" || idpersona == undefined) {
        if (this.$store.state.usuario.idtipo == 2) {
          this.personalSeleccionado = "Todo";
        } else {
          this.personalSeleccionado = this.$store.state.usuario.idpersona;
        }

        //
      } else {
        this.personalSeleccionado = idpersona;
      }
    },
    cargarPersonal() {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "personas/read/")
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.personal = respuesta.data.data;
          }
          this.proceso = false;
        })
        .catch(function (error) {
          error.log("er store" + error);
        });
    },
  },
};
</script>